import React from 'react';
import Section from '../Section/Section';
import { personalInfo } from '../../data/portfolioData';
import { openAssistant } from '../../lib/assistantBus';
import './Contact.css';

const CHANNELS = [
  { label: 'email', value: personalInfo.email, href: `mailto:${personalInfo.email}` },
  {
    label: 'phone',
    value: personalInfo.phone,
    href: `tel:${personalInfo.phone.replace(/[^\d+]/g, '')}`
  },
  { label: 'github', value: 'patilchirag2392', href: personalInfo.github },
  { label: 'linkedin', value: 'chiragp2392', href: personalInfo.linkedin },
  { label: 'based', value: personalInfo.location, href: null }
];

const QUESTIONS = [
  'What did he ship at Dyspute.ai?',
  'How does Converge merge concurrent edits?',
  'How much iOS work has he done?'
];

export const Contact = () => (
  <Section
    id="contact"
    path="contact"
    title="Contact"
    lede="Hiring for a software engineering role starting January 2027, or curious about something here? I reply within a day."
  >
    <div className="contact-grid">
      <dl className="facts">
        {CHANNELS.map((channel) => (
          <div className="facts-row" key={channel.label}>
            <dt>{channel.label}</dt>
            <dd>
              {channel.href ? (
                <a
                  className="link"
                  href={channel.href}
                  target={channel.href.startsWith('http') ? '_blank' : undefined}
                  rel={channel.href.startsWith('http') ? 'noreferrer' : undefined}
                >
                  {channel.value}
                </a>
              ) : (
                channel.value
              )}
            </dd>
          </div>
        ))}
      </dl>

      <div className="contact-ask">
        <p className="contact-ask-label">Or ask the assistant</p>
        <p className="contact-ask-note">
          It answers from what is published on this page, runs on Claude
          through a Netlify function, and nothing you type is stored by me.
        </p>
        <ul className="contact-questions">
          {QUESTIONS.map((q) => (
            <li key={q}>
              <button type="button" onClick={() => openAssistant(q)}>
                {q}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </Section>
);

export default Contact;
